//@flow
export const headerConstants = {
  CHANGE_ACTION: "CHANGE_ACTION",
  CHANGE_EXTRA_ACTION: "CHANGE_EXTRA_ACTION"
};
